webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "0gjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss__ = __webpack_require__("MYe8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_recaptcha__ = __webpack_require__("e7c0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_nanogql__);


var _templateObject = _taggedTemplateLiteralLoose(['\n        mutation Mutation($input: CreateSubmissionInput!) {\n            createSubmission(input: $input)\n        }\n    '], ['\n        mutation Mutation($input: CreateSubmissionInput!) {\n            createSubmission(input: $input)\n        }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'svg',
  { fill: '#000000', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-meh-o' });

var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'p',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'strong',
    null,
    'We strive for 100% customer satisfaction.'
  )
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'p',
  null,
  'If we fell short, please tell us more so we can address your concerns.'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default(props) {
    _classCallCheck(this, _default);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      back: false,
      reCAPTCHAKey: '',
      recaptchaResponse: '',
      name: '',
      phone: '',
      email: '',
      message: '',
      submitted: false
    };


    _this.state.reCAPTCHAKey = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].getReCAPTCHAKey();
    return _this;
  }

  _default.prototype.handleSubmit = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
      var _this2 = this;

      var promise, query, input, response, json, success;
      return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              promise = new Promise(function (resolve) {
                return _this2.setState({
                  loading: true
                }, resolve);
              });
              query = __WEBPACK_IMPORTED_MODULE_6_nanogql___default()(_templateObject);
              input = {
                name: this.state.name,
                phone: this.state.phone,
                email: this.state.email,
                message: this.state.message,
                recaptchaResponse: this.state.recaptchaResponse,
                domain: location.host
              };


              if (this.props.match.params.group && this.props.match.params.group !== 'default') {
                input.group = this.props.match.params.group;
              }

              if (this.props.match.params.key && this.props.match.params.key !== 'none') {
                input.key = this.props.match.params.key;
              }

              _context.next = 8;
              return fetch('https://api.reviews.nzdigital.co.nz/graphql', {
                method: 'POST',
                body: JSON.stringify(query({
                  input: input
                })),
                headers: {
                  'Content-Type': 'application/json'
                }
              });

            case 8:
              response = _context.sent;
              _context.next = 11;
              return response.json();

            case 11:
              json = _context.sent;
              success = json.data.createSubmission;
              _context.next = 15;
              return promise;

            case 15:
              return _context.abrupt('return', new Promise(function (resolve) {
                return _this2.setState({
                  loading: false,
                  submitted: success,
                  error: !success
                }, resolve);
              }));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    }

    return handleSubmit;
  }();

  _default.prototype.render = function render() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'content-inner-container bad-times' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'bad-times-inner' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'back', onClick: function onClick() {
              return _this3.setState({ back: true });
            } },
          _ref2
        ),
        _ref3,
        _ref4,
        _ref5,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'controls-holder' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'controls-holder-inner' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Name', onChange: function onChange(event) {
                return _this3.setState({ name: event.target.value });
              } }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Email', onChange: function onChange(event) {
                return _this3.setState({ email: event.target.value });
              } }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Phone', onChange: function onChange(event) {
                return _this3.setState({ phone: event.target.value });
              } }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('textarea', { placeholder: 'Enter Message', onChange: function onChange(event) {
                return _this3.setState({ message: event.target.value });
              } }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_recaptcha___default.a, { elementID: 'g-recaptcha', sitekey: this.state.reCAPTCHAKey, verifyCallback: function verifyCallback(response) {
                return _this3.setState({ recaptchaResponse: response });
              }, size: 'normal' }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_recaptcha___default.a, { elementID: 'g-recaptcha-compact', sitekey: this.state.reCAPTCHAKey, verifyCallback: function verifyCallback(response) {
                return _this3.setState({ recaptchaResponse: response });
              }, size: 'compact' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'submit-holder' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { disabled: this.state.loading || !(this.state.email && this.state.name && this.state.phone && this.state.message && this.state.recaptchaResponse), onClick: this.handleSubmit.bind(this) },
            'Send us your feedback'
          ),
          this.state.loading ? _ref6 : null
        )
      ),
      this.state.back ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key }) : null,
      this.state.submitted ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/feedback/thank-you' }) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "5CwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("eZ5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-smile-o' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Thanks for your feedback'
  )
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'We really appreciate any feedback we get from our customers, good or bad.'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    _classCallCheck(this, _default);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      website: ''
    };


    _this.state.website = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getWebsite();
    return _this;
  }

  _default.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'content-inner-container bad-times-thank-you' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'bad-times-thank-you-inner' },
        _ref,
        _ref2,
        _ref3,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'submit-holder' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: this.state.website, className: 'button' },
            'Visit our website'
          )
        )
      )
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ "7Q5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MYe8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify__ = __webpack_require__("ORum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_slugify__);


function getDefaultConfig() {
  return window.$$REVIEW_CONFIG = window.$$REVIEW_CONFIG || {};
}

var Config = { getConfig: function getConfig() {
    return null;
  } };

Config = {
  setConfig: function setConfig(config) {
    this.config = config;
  },
  getConfig: function getConfig() {
    var _this = this;

    var defaultConfig = getDefaultConfig();

    var config = Object.assign({}, defaultConfig, this.config || {});

    if (!this.group) {
      return config;
    }

    var groupSlug = __WEBPACK_IMPORTED_MODULE_0_slugify___default()(this.group).toLowerCase();

    var groupSettings = (config.groups || []).find(function (group) {
      return group.name.toLowerCase() === _this.group.toLowerCase() || groupSlug === __WEBPACK_IMPORTED_MODULE_0_slugify___default()(group.name).toLowerCase();
    });

    if (!groupSettings || groupSettings.disabled) {
      return config;
    }

    var settings = Object.assign({}, config);

    if (groupSettings.facebookReviewLink) {
      settings.facebookReviewLink = groupSettings.facebookReviewLink;
    }
    if (groupSettings.googleReviewLink) {
      settings.googleReviewLink = groupSettings.googleReviewLink;
    }

    return settings;
  },
  setGroup: function setGroup(group) {
    this.group = group;
  },
  getFacebookReviewLink: function getFacebookReviewLink() {
    var config = Config.getConfig();
    return config.facebookReviewLink;
  },
  getGoogleReviewLink: function getGoogleReviewLink() {
    var config = Config.getConfig();
    return config.googleReviewLink;
  },
  getReCAPTCHAKey: function getReCAPTCHAKey() {
    var config = Config.getConfig();
    return config.reCAPTCHAKey;
  },
  getNegativeFeedbackUrl: function getNegativeFeedbackUrl() {
    var config = Config.getConfig();
    return config.negativeFeedbackUrl;
  },
  getNegativeFeedbackKey: function getNegativeFeedbackKey() {
    var config = Config.getConfig();
    return config.negativeFeedbackFormKey;
  },
  getHeaderImage: function getHeaderImage() {
    var config = Config.getConfig();
    return config.headerImage;
  },
  getLogo: function getLogo() {
    var config = Config.getConfig();
    return config.logo;
  },
  getLogoMobile: function getLogoMobile() {
    var config = Config.getConfig();
    return config.logoMobile || config.logo;
  },
  getWebsite: function getWebsite() {
    var config = Config.getConfig();
    return config.website;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Config);

/***/ }),

/***/ "TJlp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZ5x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eslX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_scss__ = __webpack_require__("h5AK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__("wrym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__states_landing__ = __webpack_require__("mKIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__states_thank_you__ = __webpack_require__("rhxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__states_google__ = __webpack_require__("sr5A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__states_facebook__ = __webpack_require__("g9no");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__states_bad_times__ = __webpack_require__("0gjP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__states_bad_times_thanks__ = __webpack_require__("5CwF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_nanogql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_whatwg_fetch__ = __webpack_require__("rplX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_whatwg_fetch__);


var _templateObject = _taggedTemplateLiteralLoose(['\n      query Query($domain: String!) {\n          getDomainPortalSettings(domain: $domain) {\n              _id,\n              email,\n              name,\n              facebookReviewLink,\n              googleReviewLink,\n              headerImage,\n              logo,\n              website,\n              directorInfo,\n              groups {\n                  facebookReviewLink,\n                  googleReviewLink,\n                  name,\n                  disabled\n              }\n          }\n      }\n    '], ['\n      query Query($domain: String!) {\n          getDomainPortalSettings(domain: $domain) {\n              _id,\n              email,\n              name,\n              facebookReviewLink,\n              googleReviewLink,\n              headerImage,\n              logo,\n              website,\n              directorInfo,\n              groups {\n                  facebookReviewLink,\n                  googleReviewLink,\n                  name,\n                  disabled\n              }\n          }\n      }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["a" /* createBrowserHistory */])();
var initGA = function initGA(history) {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

  ga('create', 'UA-90741411-23', 'auto');
  ga('send', 'pageview');

  history.listen(function (location) {
    var path = location.pathname.replace(/^\/([^\/]+)\/[^\/]+\/?/, '/$1/');
    console.log("tracking page view: " + path);
    ga('send', 'pageview', path);
  });
};

initGA(history);

var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'div',
  { className: 'cs-loader' },
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: 'cs-loader-inner' },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      null,
      ' \u25CF'
    )
  )
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'div',
  { className: 'content-container' },
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Switch */],
    null,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key', exact: true, component: __WEBPACK_IMPORTED_MODULE_6__states_landing__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key/thank-you', exact: true, component: __WEBPACK_IMPORTED_MODULE_7__states_thank_you__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key/thank-you/google', exact: true, component: __WEBPACK_IMPORTED_MODULE_8__states_google__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key/thank-you/facebook', exact: true, component: __WEBPACK_IMPORTED_MODULE_9__states_facebook__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key/feedback', exact: true, component: __WEBPACK_IMPORTED_MODULE_10__states_bad_times__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Route */], { path: '/:group/:key/feedback/thank-you', exact: true, component: __WEBPACK_IMPORTED_MODULE_11__states_bad_times_thanks__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Redirect */], { to: '/default/none' })
  )
);

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      headerImage: '',
      logo: '',
      logoMobile: '',
      loading: true
    };
    return _this;
  }

  App.prototype.componentDidMount = function componentDidMount() {
    return this.fetchSettings().catch(function (error) {
      console.warn(error);
      alert('Unable to load');
    });
  };

  App.prototype.fetchSettings = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      var query, response, json;
      return __WEBPACK_IMPORTED_MODULE_0__opt_atlassian_pipelines_agent_build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = __WEBPACK_IMPORTED_MODULE_12_nanogql___default()(_templateObject);
              _context.next = 3;
              return fetch('https://api.reviews.nzdigital.co.nz/graphql', {
                method: 'POST',
                body: JSON.stringify(query({
                  domain: location.host
                })),
                headers: {
                  'Content-Type': 'application/json'
                }
              });

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();

            case 6:
              json = _context.sent;

              if (json && json.data && json.data.getDomainPortalSettings) {
                _context.next = 10;
                break;
              }

              alert('Unabled to load settings');
              return _context.abrupt('return');

            case 10:

              __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].setConfig(json.data.getDomainPortalSettings);

              return _context.abrupt('return', new Promise(function (resolve) {
                return _this2.setState({
                  loading: false,
                  config: json.data.getDomainPortalSettings,
                  headerImage: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getHeaderImage(),
                  logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getLogo(),
                  logoMobile: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getLogoMobile()
                });
              }));

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchSettings() {
      return _ref.apply(this, arguments);
    }

    return fetchSettings;
  }();

  App.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Router */],
      { history: history },
      this.state.loading ? _ref2 : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'app' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'style',
          { type: 'text/css' },
          '\n                  .app:before {\n                    background-image:url(' + this.state.headerImage + ');\n                  }\n                '
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'logo-container', style: { backgroundImage: 'url(' + this.state.headerImage + ')' } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'logo-inner-container' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: this.state.logo, className: 'desktop' }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: this.state.logoMobile, className: 'mobile' })
          )
        ),
        _ref3
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ "g9no":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("gOcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'svg',
  { fill: '#000000', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-facebook' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'Facebook lets us stay connected with our customers, fans and friends - and lets you review businesses.'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'desktop', src: '/images/facebook images.png' });

var _ref5 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  { className: 'explainer' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    '"Like"'
  ),
  ' our page if you want to stay connected with us',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  'Find the ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    '"Reviews"'
  ),
  ' widget in the body of the page and rate us.',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Log in'
  ),
  ' or ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'sign up'
  ),
  ' if you haven\'t already to complete the process'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  { className: 'explainer note' },
  'Note: This website is not affiliated with or endorsed by Facebook.'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      back: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.openFacebook = function openFacebook() {

    __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].setGroup(this.props.match.params.group);
    window.open(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getFacebookReviewLink(), '_blank');
  };

  _default.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'content-inner-container facebook' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'facebook-inner' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'back', onClick: function onClick() {
              return _this2.setState({ back: true });
            } },
          _ref
        ),
        _ref2,
        _ref3,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { onClick: this.openFacebook.bind(this), className: 'mobile' },
          'Click to review us on Facebook'
        ),
        _ref4,
        _ref5,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { onClick: this.openFacebook.bind(this), className: 'desktop' },
          'Click to review us on Facebook'
        ),
        _ref6
      ),
      this.state.back ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/thank-you' }) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ "gOcK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h5AK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hdpt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("iCOP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__("eslX");







Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */], null), document.querySelector('#app'));

/***/ }),

/***/ "mKIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("TJlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'Please take a moment to review your experience with us. Your feedback not only helps us, it helps other potential clients.'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-smile-o' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'I had a good experience'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-meh-o' });

var _ref5 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'I had a bad experience'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default(props) {
    _classCallCheck(this, _default);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      positive: false,
      negative: false
    };


    __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].setGroup(props.match.params.group);
    return _this;
  }

  _default.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'content-inner-container landing' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'landing-inner' },
        _ref,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rank-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rank rank-up', onClick: function onClick() {
                return _this2.setState({ positive: true });
              } },
            _ref2,
            _ref3
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rank rank-down', onClick: function onClick() {
                return _this2.setState({ negative: true });
              } },
            _ref4,
            _ref5
          )
        )
      ),
      this.state.negative ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/feedback' }) : null,
      this.state.positive ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/thank-you' }) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ "rhxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("7Q5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-smile-o' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Thank you!'
  )
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'We need your help. Would you share your experience on one of these sites?'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-facebook' });

var _ref5 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Facebook'
  )
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-google' });

var _ref7 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Google'
  )
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      facebook: false,
      google: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'content-inner-container thank-you' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'thank-you-inner' },
        _ref,
        _ref2,
        _ref3,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'sites-holder' },
          console.log(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getFacebookReviewLink()),
          __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getFacebookReviewLink() === '' ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'site', onClick: function onClick() {
                return _this2.setState({ facebook: true });
              } },
            _ref4,
            _ref5
          ),
          __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getGoogleReviewLink() === '' ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'site', onClick: function onClick() {
                return _this2.setState({ google: true });
              } },
            _ref6,
            _ref7
          )
        )
      ),
      this.state.facebook ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/thank-you/facebook' }) : null,
      this.state.google ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/thank-you/google' }) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ "sr5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("hdpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("QmSG");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'svg',
  { fill: '#000000', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-google' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  null,
  'Google lets us stay connected with our customers, fans and friends - and lets you review businesses.'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'desktop', src: '/images/google stars.png' });

var _ref5 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  { className: 'explainer' },
  'Click on the ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    '"Write a review"'
  ),
  ' button',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'strong',
    null,
    'Sign in'
  ),
  ' with your Google account ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  'Then simply select a stay rating then write a description of your experience of the business.'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'p',
  { className: 'explainer note' },
  'Note: This website is not affiliated with or endorsed by Google.'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      back: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.openGoogle = function openGoogle() {
    __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].setGroup(this.props.match.params.group);
    window.open(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].getGoogleReviewLink(), '_blank');
  };

  _default.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'content-inner-container google' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'google-inner' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'back', onClick: function onClick() {
              return _this2.setState({ back: true });
            } },
          _ref
        ),
        _ref2,
        _ref3,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { onClick: this.openGoogle.bind(this), className: 'mobile' },
          'Click to review us on Google'
        ),
        _ref4,
        _ref5,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { onClick: this.openGoogle.bind(this), className: 'desktop' },
          'Click to review us on Google'
        ),
        _ref6
      ),
      this.state.back ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */], { to: '/' + this.props.match.params.group + '/' + this.props.match.params.key + '/thank-you' }) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ })

},[0]);


// WEBPACK FOOTER //
// app.600e9fca.js